<template>
  <check-box
    :initial-value="wishList.productIds.includes(productId)"
    :field-name="`wishlist-${wishList.id}`"
    :field-label="wishList.name"
    :handling-change="submitStatus === 1"
    @on-change="handleChange($event)" />
</template>

<script setup lang="ts">
import CheckBox from "~/components/UI/CheckBox.vue";
import type { WishlistAll } from "~/stores/types/wishlist";
import { useProductStore } from "~/stores/product";
import { ref } from "#imports";

const productStore = useProductStore();

const emit = defineEmits(['on-update']);

const props = defineProps<{
  wishList: WishlistAll,
  productId: number|string,
}>();

const submitStatus = ref(0);

const handleChange = async (addItem) => {
  if (submitStatus.value !== 1) {
    submitStatus.value = 1;
    await productStore.changeWishlistStatus(props.productId, props.wishList.id, addItem)
      .then((data) => {
        submitStatus.value = 2;
        emit('on-update', {
          message: data.message,
          status: data.status,
        });
      }).catch(() => {
        submitStatus.value = -1;
      });
  }
}
</script>
